import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

interface VisitTimelineBulletProps {
  confirmed: boolean;
}

export const VisitTimelineBullet = ({
  confirmed,
}: VisitTimelineBulletProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "relative z-10 flex h-7 w-7 shrink-0 items-center justify-center rounded-full",
        confirmed
          ? "bg-primary text-primary-foreground"
          : "border border-muted bg-background"
      )}
      aria-label={confirmed ? t("confirmed") : undefined}
      data-test-id={confirmed ? "visit-confirmed-bullet" : undefined}
    >
      {confirmed ? (
        <Check className="h-3.5 w-3.5" />
      ) : (
        <div className="h-2.5 w-2.5 rounded-full bg-primary/20" />
      )}
    </div>
  );
};
